import { css } from '@linaria/core';
import { styled } from '@linaria/react';

const StyledButton = styled.button`
  align-items: center;
  background-color: ${props => {
    switch (props.variant) {
      case 'primary':
        return '#f8bb25';
      case 'secondary':
        return '#ffffff';
      case 'neutral':
        return '#e5dbd1';
      default:
        return '#f8bb25';
    }
  }};
  border: 1px solid #000000;
  border-radius: 5px;
  color: #000000;
  display: inline-flex;
  font-size: 18px;
  height: ${props => {
    switch (props.size) {
      case 'small':
        return '40px';
      case 'medium':
      default:
        return '52px';
    }
  }};
  justify-content: center;
  line-height: 28px;
  padding: 12px 30px;
  text-align: left;
  transition: background-color 300ms ease-in-out;

  &:focus {
    background-color: ${props => {
      switch (props.variant) {
        case 'primary':
        case 'secondary':
          return '#000000';
        case 'neutral':
          return '#e5dbd1';
        default:
          return '#f8bb25';
      }
    }};
    box-shadow: 0 0 0 3px #ffdd00;
    color: ${props => {
      switch (props.variant) {
        case 'primary':
        case 'secondary':
          return '#ffffff';
        case 'neutral':
          return '#000000';
        default:
          return '#ffffff';
      }
    }};
  }

  &:hover {
    background-color: ${props => {
      switch (props.variant) {
        case 'primary':
          return '#fcdd92';
        case 'secondary':
          return '#f8bb25';
        case 'neutral':
          return '#ffffff';
        default:
          return '#f8bb25';
      }
    }};
    color: #000000;
  }

  &:disabled {
    background-color: ${props => {
      switch (props.variant) {
        case 'primary':
        case 'secondary':
          return '#f8bb25';
        case 'neutral':
          return '#e5dbd1';
        default:
          return '#f8bb25';
      }
    }};
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const icon = css`
  fill: currentColor;
  height: 20px;
`;
const startIcon = css`
  margin-right: 10px;
`;
const endIcon = css`
  margin-left: 10px;
`;

export default function Button({
  StartIcon,
  EndIcon,
  children,
  innerRef,
  ...rest
}) {
  return (
    <>
      <StyledButton ref={innerRef} {...rest}>
        {StartIcon && <StartIcon className={`${icon} ${startIcon}`} />}
        {children}
        {EndIcon && <EndIcon className={`${icon} ${endIcon}`} />}
      </StyledButton>
    </>
  );
}
